import React from "react";

export function MyAccount() {
	return <div>My Account page</div>;
}
